export const extraMessages = {
  gl: {
    nav: {
      language: 'Cambiar idioma',
    },
    header: {
      brandName: 'Banda de Música',
      brandLocation: 'Noia · 1890',
      booking: 'Contratación',
      mainNavLabel: 'Navegación principal',
      mobileNavLabel: 'Navegación móbil',
      openMenu: 'Abrir menú',
      closeMenu: 'Pechar menú',
      admin: 'Admin',
      login: 'Login',
    },
    footer: {
      brandName: 'Banda de Música de Noia',
      brandTagline: 'Tradición musical dende 1890',
      schoolLink: 'Escola de Música',
    },
    home: {
      heroEyebrow: 'Banda de Música de Noia',
      heroTitle: 'Tradición musical dende 1890',
      heroSubtitle: 'Tradición, escola e concertos para manter a música popular galega en movemento.',
      ctaEvents: 'Ver calendario',
      ctaAbout: 'Coñécenos',
      factsYears: 'Anos de historia',
      factsMusicians: 'Músicos en activo',
      factsSchool: 'Canteira propia',
      imageCaption: 'Compromiso coa música de banda en Noia e comarca.',
      nextConcertLabel: 'Próxima actuación',
      nextConcertTitle: 'Axenda en actualización semanal',
      nextConcertLoading: 'Cargando próxima data...',
      nextConcertLocation: 'Noia e área metropolitana',
      nextConcertTimePrefix: 'Hora:',
      nextConcertAllDay: 'Evento de día completo',
      nextConcertSchedule: 'Consulta datas confirmadas no calendario',
      nextConcertUpdates: 'Publicación continua de novas actuacións',
      nextConcertButton: 'Ir a próximas actuacións',
      editorialEyebrow: 'Programa',
      editorialTitle: 'Un proxecto cultural con tres frontes',
      editorialSubtitle: 'Actividade artística, formación e presenza social: unha banda de pobo pensada para durar.',
      cardHistoryTitle: 'A nosa historia',
      cardHistoryText: 'Dende 1890 construindo memoria colectiva a través de concertos, pasarruas e colaboracións locais.',
      cardHistoryLink: 'Explorar historia',
      cardSchoolTitle: 'Escola de música',
      cardSchoolText: 'Un itinerario de aprendizaxe real para formar novos intérpretes e garantir relevo xeracional.',
      cardSchoolLink: 'Ver escola',
      cardEventsTitle: 'Actuacións e eventos',
      cardEventsText: 'Calendario aberto con festas, certames e concertos para manter o repertorio en contacto co público.',
      cardEventsLink: 'Ir ao calendario',
      statFounding: 'Ano de fundación',
      statYears: 'Anos de traxectoria',
      statMoments: 'Momentos compartidos',
      galleryEyebrow: 'Arquivo visual',
      galleryTitle: 'Escenarios, ensaios e comunidade',
      ctaEyebrow: 'Colaboracións',
      ctaTitle: 'Queres contar coa banda no teu evento?',
      ctaText: 'Programamos actuacións para festas, encontros culturais e datas especiais en toda a comarca.',
      ctaButton: 'Solicitar información',
      altLogo: 'Logo da Banda de Música de Noia',
      altPerformance: 'Actuación da Banda de Música de Noia',
      altConcert: 'Concerto da Banda de Música de Noia',
      altEvent: 'Evento da Banda de Música de Noia',
      altPresentation: 'Presentación da Banda de Música de Noia',
      altInAction: 'Banda de Música de Noia en acción',
      imageAltDefault: 'Imaxe da Banda de Música de Noia',
    },
    about: {
      galleryEyebrow: 'A nosa historia',
      galleryTitle: 'En imaxes',
      gallerySubtitle: 'Un percorrido visual polos nosos momentos',
      sectionBeginningsTitle: 'Os Nosos Comezos',
      sectionBeginningsText: 'A Banda de Música de Noia naceu en 1890 e foi a banda sonora da vila ata mediados dos anos 50, cando a súa actividade se interrompeu. En 1984 renaceu con forza, regresando aos escenarios no Venres de Dores e converténdose de novo nun emblema cultural de Noia.',
      sectionInternationalTitle: 'Actuacións Internacionais',
      sectionInternationalText: 'Dende a súa reorganización, a banda levou a música de Noia por Galicia e fóra dela. En 1989 viaxou a Arxentina e actuou en escenarios como a Casa Rosada e o Centro Galego de Bos Aires, celebrando o Día da Hispanidade ante milleiros de persoas.',
      sectionHighlightsTitle: 'Momentos Destacados',
      sectionHighlightsText: 'No camiño quedaron fitos como o terceiro posto no certame de Cangas (1987), a homenaxe a Felipe Paz co nome do Conservatorio de Noia (1992) e a apertura da Escola de Música (2004). Tamén o Certame de Bandas de Cuenca (2006) e o concerto no Teatro Colón da Coruña polo centenario do Himno Galego (2008).',
      sectionRecognitionTitle: 'Recoñecementos',
      sectionRecognitionText: 'Tras a pandemia chegou unha reactivación: en 2021 participou en O País das Bandas. En 2023 realizouse intercambio con El Bemol (Galapagar) e coa Banda Maestro Nacor Blanco (Zamora), e destacaron concertos con Rubén Simeó, incluído o proxecto con Simant Duo. No ano 2025 a Escola de Música retomou a plena actividade con 4 docentes e arredor de 20 alumnos, reforzando a canteira local.',
      sectionFutureTitle: 'Futuro Prometedor',
      sectionFutureText: 'A banda realiza máis de vinte actuacións anuais en Noia e colabora con entidades locais como a Coral Polifónica, o Liceo ou o coro Canta para Noia. Mantén unha actividade social activa, con concertos benéficos e festivais que achegan a música a toda a veciñanza.',
      ctaTitle: 'Forma parte da nosa historia',
      ctaText: 'Estamos sempre abertos a novos músicos que queiran unirse á nosa familia musical e escribir xuntos o seguinte capítulo da nosa historia.',
      ctaButton: 'Contacta connosco',
      timeline1880: 'Fundación das primeiras agrupacións musicais',
      timeline1984: 'Reorganización baixo Miguel Fernández Pestonit',
      timeline1989: 'Xira histórica pola Arxentina',
      timeline2006: 'Éxito no Certame de Cuenca',
      timeline2008: 'Actuación no Teatro Colón',
      timeline2025: 'Reorganización da Escola de Música e nova etapa',
      imageAltDefault: 'Imaxe da Banda de Música de Noia',
    },
    school: {
      heroEyebrowFallback: 'Formación Musical',
      heroTitleFallback: 'Escola de Música',
      heroSubtitleFallback: 'Especialidades en Música e Movemento, Linguaxe Musical e múltiples instrumentos',
      heroCtaContact: 'Solicitar info',
      heroCtaEvents: 'Ver próximas actuacións',
      specialtiesTitle: 'Especialidades Ofertadas',
      specialtiesSubtitle: 'Formación especializada en diferentes áreas musicais',
      specialtyMovementTitle: 'Música e Movemento',
      specialtyMovementText: 'Desenvolvemento integral da expresividade corporal e musical. Actividades que combinan o movemento, o ritmo e a música para fomentar a coordinación e a creatividade.',
      specialtyLanguageTitle: 'Linguaxe Musical',
      specialtyLanguageText: 'Fundamentos teóricos da música: lectura, escritura, teoría musical e comprensión dos conceptos básicos que permiten desenvolver a formación musical completa.',
      specialtyInstrumentsTitle: 'Instrumentos',
      specialtyInstrumentsText: 'Formación especializada nos seguintes instrumentos:',
      instrumentClarinet: 'Clarinete',
      instrumentSaxophone: 'Saxofón',
      instrumentFlute: 'Frauta',
      instrumentEuphonium: 'Bombardino',
      instrumentTrombone: 'Trombón',
      instrumentTrumpet: 'Trompeta',
      instrumentPercussion: 'Percusión',
      paginationFirst: 'Primeira páxina',
      paginationPrev: 'Páxina anterior',
      paginationNext: 'Páxina seguinte',
      paginationLast: 'Última páxina',
    },
    events: {
      ctaButton: 'Contáctanos',
    },
    music: {
      followFacebook: 'Facebook',
      followInstagram: 'Instagram',
    },
    login: {
      title: 'Acceso de administrador',
      subtitle: 'Introduce as túas credenciais para acceder ao panel de administración',
      emailLabel: 'Correo electrónico',
      emailPlaceholder: 'admin@bandademusica.com',
      passwordLabel: 'Contrasinal',
      passwordPlaceholder: '••••••••',
      submit: 'Iniciar sesión',
      backHome: 'Volver ao inicio',
      deniedMessage: 'A túa conta non ten permisos para acceder ao panel de administración',
      deniedTitle: 'Acceso denegado',
      requiredMessage: 'Por favor, completa todos os campos',
      requiredTitle: 'Campos obrigatorios',
    },
    admin: {
      panelTitle: 'Panel Admin',
      role: 'Administrador',
      logout: 'Pechar sesión',
      openMenu: 'Abrir menú',
      closeMenu: 'Pechar menú',
      expand: 'Expandir',
      collapse: 'Contraer',
      tabDashboard: 'Dashboard',
      tabNews: 'Noticias',
      tabSchool: 'Escola',
      tabSchoolNews: 'Noticias Escola',
      subtitleDashboard: 'Vista xeral do teu panel de administración',
      subtitleNews: 'Xestiona as noticias e artigos publicados',
      subtitleSchool: 'Administra o contido da páxina da escola',
      subtitleSchoolNews: 'Xestiona as noticias relacionadas coa escola',
      deleteTitle: 'Confirmar eliminación',
      deleteQuestionStart: 'Estás seguro de que queres eliminar a noticia',
      deleteQuestionEnd: '?',
      deleteWarning: 'Esta acción non se pode desfacer.',
      cancel: 'Cancelar',
      accept: 'Aceptar',
      editNewsTitle: 'Editar noticia',
      editSchoolNewsTitle: 'Editar noticia da escola',
      fieldTitle: 'Título',
      fieldContent: 'Contido',
      fieldPublishDate: 'Data de publicación',
      saveChanges: 'Gardar cambios',
      quillPlaceholder: 'Escribe o contido da noticia aquí...',
    },
  },
  es: {
    nav: {
      language: 'Cambiar idioma',
    },
    header: {
      brandName: 'Banda de Música',
      brandLocation: 'Noia · 1890',
      booking: 'Contratación',
      mainNavLabel: 'Navegación principal',
      mobileNavLabel: 'Navegación móvil',
      openMenu: 'Abrir menú',
      closeMenu: 'Cerrar menú',
      admin: 'Admin',
      login: 'Login',
    },
    footer: {
      brandName: 'Banda de Música de Noia',
      brandTagline: 'Tradición musical desde 1890',
      schoolLink: 'Escuela de Música',
    },
    home: {
      heroEyebrow: 'Banda de Música de Noia',
      heroTitle: 'Tradición musical desde 1890',
      heroSubtitle: 'Tradición, escuela y conciertos para mantener la música popular gallega en movimiento.',
      ctaEvents: 'Ver calendario',
      ctaAbout: 'Conócenos',
      factsYears: 'Años de historia',
      factsMusicians: 'Músicos en activo',
      factsSchool: 'Cantera propia',
      imageCaption: 'Compromiso con la música de banda en Noia y comarca.',
      nextConcertLabel: 'Próxima actuación',
      nextConcertTitle: 'Agenda en actualización semanal',
      nextConcertLoading: 'Cargando próxima fecha...',
      nextConcertLocation: 'Noia y área metropolitana',
      nextConcertTimePrefix: 'Hora:',
      nextConcertAllDay: 'Evento de día completo',
      nextConcertSchedule: 'Consulta fechas confirmadas en el calendario',
      nextConcertUpdates: 'Publicación continua de nuevas actuaciones',
      nextConcertButton: 'Ir a próximas actuaciones',
      editorialEyebrow: 'Programa',
      editorialTitle: 'Un proyecto cultural con tres frentes',
      editorialSubtitle: 'Actividad artística, formación y presencia social: una banda de pueblo pensada para durar.',
      cardHistoryTitle: 'Nuestra historia',
      cardHistoryText: 'Desde 1890 construyendo memoria colectiva a través de conciertos, pasacalles y colaboraciones locales.',
      cardHistoryLink: 'Explorar historia',
      cardSchoolTitle: 'Escuela de música',
      cardSchoolText: 'Un itinerario de aprendizaje real para formar nuevos intérpretes y garantizar relevo generacional.',
      cardSchoolLink: 'Ver escuela',
      cardEventsTitle: 'Actuaciones y eventos',
      cardEventsText: 'Calendario abierto con fiestas, certámenes y conciertos para mantener el repertorio en contacto con el público.',
      cardEventsLink: 'Ir al calendario',
      statFounding: 'Año de fundación',
      statYears: 'Años de trayectoria',
      statMoments: 'Momentos compartidos',
      galleryEyebrow: 'Archivo visual',
      galleryTitle: 'Escenarios, ensayos y comunidad',
      ctaEyebrow: 'Colaboraciones',
      ctaTitle: '¿Quieres contar con la banda en tu evento?',
      ctaText: 'Programamos actuaciones para fiestas, encuentros culturales y fechas especiales en toda la comarca.',
      ctaButton: 'Solicitar información',
      altLogo: 'Logo de la Banda de Música de Noia',
      altPerformance: 'Actuación de la Banda de Música de Noia',
      altConcert: 'Concierto de la Banda de Música de Noia',
      altEvent: 'Evento de la Banda de Música de Noia',
      altPresentation: 'Presentación de la Banda de Música de Noia',
      altInAction: 'Banda de Música de Noia en acción',
      imageAltDefault: 'Imagen de la Banda de Música de Noia',
    },
    about: {
      galleryEyebrow: 'Nuestra historia',
      galleryTitle: 'En imágenes',
      gallerySubtitle: 'Un recorrido visual por nuestros momentos',
      sectionBeginningsTitle: 'Nuestros comienzos',
      sectionBeginningsText: 'La Banda de Música de Noia nació en 1890 y fue la banda sonora de la villa hasta mediados de los años 50, cuando su actividad se interrumpió. En 1984 renació con fuerza, regresando a los escenarios en el Viernes de Dolores y convirtiéndose de nuevo en un emblema cultural de Noia.',
      sectionInternationalTitle: 'Actuaciones internacionales',
      sectionInternationalText: 'Desde su reorganización, la banda llevó la música de Noia por Galicia y fuera de ella. En 1989 viajó a Argentina y actuó en escenarios como la Casa Rosada y el Centro Gallego de Buenos Aires, celebrando el Día de la Hispanidad ante miles de personas.',
      sectionHighlightsTitle: 'Momentos destacados',
      sectionHighlightsText: 'En el camino quedaron hitos como el tercer puesto en el certamen de Cangas (1987), el homenaje a Felipe Paz con el nombre del Conservatorio de Noia (1992) y la apertura de la Escuela de Música (2004). También el Certamen de Bandas de Cuenca (2006) y el concierto en el Teatro Colón de A Coruña por el centenario del Himno Gallego (2008).',
      sectionRecognitionTitle: 'Reconocimientos',
      sectionRecognitionText: 'Tras la pandemia llegó una reactivación: en 2021 participó en O País das Bandas. En 2023 se realizó intercambio con El Bemol (Galapagar) y con la Banda Maestro Nacor Blanco (Zamora), y destacaron conciertos con Rubén Simeó, incluido el proyecto con Simant Duo. En 2025 la Escuela de Música retomó su actividad plena con 4 docentes y alrededor de 20 alumnos, reforzando la cantera local.',
      sectionFutureTitle: 'Futuro prometedor',
      sectionFutureText: 'La banda realiza más de veinte actuaciones anuales en Noia y colabora con entidades locales como la Coral Polifónica, el Liceo o el coro Canta para Noia. Mantiene una actividad social activa, con conciertos benéficos y festivales que acercan la música a toda la vecindad.',
      ctaTitle: 'Forma parte de nuestra historia',
      ctaText: 'Estamos siempre abiertos a nuevos músicos que quieran unirse a nuestra familia musical y escribir juntos el siguiente capítulo de nuestra historia.',
      ctaButton: 'Contacta con nosotros',
      timeline1880: 'Fundación de las primeras agrupaciones musicales',
      timeline1984: 'Reorganización bajo Miguel Fernández Pestonit',
      timeline1989: 'Gira histórica por Argentina',
      timeline2006: 'Éxito en el Certamen de Cuenca',
      timeline2008: 'Actuación en el Teatro Colón',
      timeline2025: 'Reorganización de la Escuela de Música y nueva etapa',
      imageAltDefault: 'Imagen de la Banda de Música de Noia',
    },
    school: {
      heroEyebrowFallback: 'Formación musical',
      heroTitleFallback: 'Escuela de Música',
      heroSubtitleFallback: 'Especialidades en Música y Movimiento, Lenguaje Musical y múltiples instrumentos',
      heroCtaContact: 'Solicitar info',
      heroCtaEvents: 'Ver próximas actuaciones',
      specialtiesTitle: 'Especialidades ofertadas',
      specialtiesSubtitle: 'Formación especializada en diferentes áreas musicales',
      specialtyMovementTitle: 'Música y movimiento',
      specialtyMovementText: 'Desarrollo integral de la expresividad corporal y musical. Actividades que combinan movimiento, ritmo y música para fomentar coordinación y creatividad.',
      specialtyLanguageTitle: 'Lenguaje musical',
      specialtyLanguageText: 'Fundamentos teóricos de la música: lectura, escritura, teoría musical y comprensión de conceptos básicos para una formación completa.',
      specialtyInstrumentsTitle: 'Instrumentos',
      specialtyInstrumentsText: 'Formación especializada en los siguientes instrumentos:',
      instrumentClarinet: 'Clarinete',
      instrumentSaxophone: 'Saxofón',
      instrumentFlute: 'Flauta',
      instrumentEuphonium: 'Bombardino',
      instrumentTrombone: 'Trombón',
      instrumentTrumpet: 'Trompeta',
      instrumentPercussion: 'Percusión',
      paginationFirst: 'Primera página',
      paginationPrev: 'Página anterior',
      paginationNext: 'Página siguiente',
      paginationLast: 'Última página',
    },
    events: {
      ctaButton: 'Contáctanos',
    },
    music: {
      followFacebook: 'Facebook',
      followInstagram: 'Instagram',
    },
    login: {
      title: 'Acceso de administrador',
      subtitle: 'Introduce tus credenciales para acceder al panel de administración',
      emailLabel: 'Correo electrónico',
      emailPlaceholder: 'admin@bandademusica.com',
      passwordLabel: 'Contraseña',
      passwordPlaceholder: '••••••••',
      submit: 'Iniciar sesión',
      backHome: 'Volver al inicio',
      deniedMessage: 'Tu cuenta no tiene permisos para acceder al panel de administración',
      deniedTitle: 'Acceso denegado',
      requiredMessage: 'Por favor, completa todos los campos',
      requiredTitle: 'Campos requeridos',
    },
    admin: {
      panelTitle: 'Panel admin',
      role: 'Administrador',
      logout: 'Cerrar sesión',
      openMenu: 'Abrir menú',
      closeMenu: 'Cerrar menú',
      expand: 'Expandir',
      collapse: 'Contraer',
      tabDashboard: 'Dashboard',
      tabNews: 'Noticias',
      tabSchool: 'Escuela',
      tabSchoolNews: 'Noticias escuela',
      subtitleDashboard: 'Vista general de tu panel de administración',
      subtitleNews: 'Gestiona las noticias y artículos publicados',
      subtitleSchool: 'Administra el contenido de la página de escuela',
      subtitleSchoolNews: 'Gestiona las noticias relacionadas con la escuela',
      deleteTitle: 'Confirmar eliminación',
      deleteQuestionStart: '¿Estás seguro de que quieres eliminar la noticia',
      deleteQuestionEnd: '?',
      deleteWarning: 'Esta acción no se puede deshacer.',
      cancel: 'Cancelar',
      accept: 'Aceptar',
      editNewsTitle: 'Editar noticia',
      editSchoolNewsTitle: 'Editar noticia de la escuela',
      fieldTitle: 'Título',
      fieldContent: 'Contenido',
      fieldPublishDate: 'Fecha de publicación',
      saveChanges: 'Guardar cambios',
      quillPlaceholder: 'Escribe el contenido de la noticia aquí...',
    },
  },
  en: {
    nav: {
      language: 'Change language',
    },
    header: {
      brandName: 'Music Band',
      brandLocation: 'Noia · 1890',
      booking: 'Book us',
      mainNavLabel: 'Main navigation',
      mobileNavLabel: 'Mobile navigation',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      admin: 'Admin',
      login: 'Login',
    },
    footer: {
      brandName: 'Noia Music Band',
      brandTagline: 'Musical tradition since 1890',
      schoolLink: 'Music School',
    },
    home: {
      heroEyebrow: 'Noia Music Band',
      heroTitle: 'Musical tradition since 1890',
      heroSubtitle: 'Tradition, school and concerts to keep Galician popular music in motion.',
      ctaEvents: 'View calendar',
      ctaAbout: 'Meet us',
      factsYears: 'Years of history',
      factsMusicians: 'Active musicians',
      factsSchool: 'Own academy',
      imageCaption: 'Commitment to concert band music in Noia and the region.',
      nextConcertLabel: 'Next performance',
      nextConcertTitle: 'Weekly updated schedule',
      nextConcertLoading: 'Loading next date...',
      nextConcertLocation: 'Noia and metropolitan area',
      nextConcertTimePrefix: 'Time:',
      nextConcertAllDay: 'All-day event',
      nextConcertSchedule: 'Check confirmed dates in the calendar',
      nextConcertUpdates: 'Continuous publication of new performances',
      nextConcertButton: 'Go to upcoming performances',
      editorialEyebrow: 'Program',
      editorialTitle: 'A cultural project on three fronts',
      editorialSubtitle: 'Artistic activity, education and social presence: a town band built to last.',
      cardHistoryTitle: 'Our history',
      cardHistoryText: 'Since 1890 building collective memory through concerts, street performances and local collaborations.',
      cardHistoryLink: 'Explore history',
      cardSchoolTitle: 'Music school',
      cardSchoolText: 'A real learning path to train new performers and ensure generational renewal.',
      cardSchoolLink: 'View school',
      cardEventsTitle: 'Performances and events',
      cardEventsText: 'Open calendar with festivities, competitions and concerts to keep repertoire close to the audience.',
      cardEventsLink: 'Go to calendar',
      statFounding: 'Founding year',
      statYears: 'Years of journey',
      statMoments: 'Shared moments',
      galleryEyebrow: 'Visual archive',
      galleryTitle: 'Stages, rehearsals and community',
      ctaEyebrow: 'Collaborations',
      ctaTitle: 'Do you want the band at your event?',
      ctaText: 'We schedule performances for festivals, cultural meetings and special dates across the region.',
      ctaButton: 'Request information',
      altLogo: 'Noia Music Band logo',
      altPerformance: 'Noia Music Band performance',
      altConcert: 'Noia Music Band concert',
      altEvent: 'Noia Music Band event',
      altPresentation: 'Noia Music Band presentation',
      altInAction: 'Noia Music Band in action',
      imageAltDefault: 'Noia Music Band image',
    },
    about: {
      galleryEyebrow: 'Our history',
      galleryTitle: 'In pictures',
      gallerySubtitle: 'A visual journey through our milestones',
      sectionBeginningsTitle: 'Our beginnings',
      sectionBeginningsText: 'The Noia Music Band was founded in 1890 and remained the town soundtrack until the mid-1950s, when activity stopped. In 1984 it was revived, returning to stages on Good Friday and becoming a cultural symbol of Noia again.',
      sectionInternationalTitle: 'International performances',
      sectionInternationalText: 'Since its reorganization, the band has taken Noia music across Galicia and beyond. In 1989 it traveled to Argentina and performed in venues such as Casa Rosada and Centro Gallego in Buenos Aires during Hispanic Heritage celebrations.',
      sectionHighlightsTitle: 'Highlights',
      sectionHighlightsText: 'Milestones include third place in Cangas competition (1987), the tribute to Felipe Paz naming the Noia Conservatory (1992), the opening of the Music School (2004), Cuenca Band Competition (2006) and Teatro Colon concert in A Coruna (2008).',
      sectionRecognitionTitle: 'Recognition',
      sectionRecognitionText: 'After the pandemic came reactivation: participation in O Pais das Bandas (2021), exchanges with El Bemol (Galapagar) and Banda Maestro Nacor Blanco (Zamora) in 2023, and concerts with Ruben Simeo including the Simant Duo project.',
      sectionFutureTitle: 'Promising future',
      sectionFutureText: 'The band performs more than twenty times a year in Noia and collaborates with local entities while keeping strong social activity through charity concerts and festivals for the whole community.',
      ctaTitle: 'Be part of our story',
      ctaText: 'We are always open to new musicians who want to join our musical family and write the next chapter with us.',
      ctaButton: 'Contact us',
      timeline1880: 'Foundation of the first local music groups',
      timeline1984: 'Reorganization under Miguel Fernandez Pestonit',
      timeline1989: 'Historic tour in Argentina',
      timeline2006: 'Success at Cuenca competition',
      timeline2008: 'Performance at Teatro Colon',
      timeline2025: 'Music School reorganization and new stage',
      imageAltDefault: 'Noia Music Band image',
    },
    school: {
      heroEyebrowFallback: 'Music education',
      heroTitleFallback: 'Music School',
      heroSubtitleFallback: 'Specialties in Music and Movement, Music Language and multiple instruments',
      heroCtaContact: 'Request info',
      heroCtaEvents: 'See upcoming performances',
      specialtiesTitle: 'Available specialties',
      specialtiesSubtitle: 'Specialized training in different music areas',
      specialtyMovementTitle: 'Music and movement',
      specialtyMovementText: 'Integrated development of body and musical expression through movement, rhythm and music to foster coordination and creativity.',
      specialtyLanguageTitle: 'Music language',
      specialtyLanguageText: 'Theoretical foundations of music: reading, writing, theory and understanding core concepts for complete musical training.',
      specialtyInstrumentsTitle: 'Instruments',
      specialtyInstrumentsText: 'Specialized training in the following instruments:',
      instrumentClarinet: 'Clarinet',
      instrumentSaxophone: 'Saxophone',
      instrumentFlute: 'Flute',
      instrumentEuphonium: 'Euphonium',
      instrumentTrombone: 'Trombone',
      instrumentTrumpet: 'Trumpet',
      instrumentPercussion: 'Percussion',
      paginationFirst: 'First page',
      paginationPrev: 'Previous page',
      paginationNext: 'Next page',
      paginationLast: 'Last page',
    },
    events: {
      ctaButton: 'Contact us',
    },
    music: {
      followFacebook: 'Facebook',
      followInstagram: 'Instagram',
    },
    login: {
      title: 'Administrator access',
      subtitle: 'Enter your credentials to access the administration panel',
      emailLabel: 'Email',
      emailPlaceholder: 'admin@bandademusica.com',
      passwordLabel: 'Password',
      passwordPlaceholder: '••••••••',
      submit: 'Sign in',
      backHome: 'Back to home',
      deniedMessage: 'Your account does not have permission to access the administration panel',
      deniedTitle: 'Access denied',
      requiredMessage: 'Please complete all fields',
      requiredTitle: 'Required fields',
    },
    admin: {
      panelTitle: 'Admin panel',
      role: 'Administrator',
      logout: 'Sign out',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      expand: 'Expand',
      collapse: 'Collapse',
      tabDashboard: 'Dashboard',
      tabNews: 'News',
      tabSchool: 'School',
      tabSchoolNews: 'School news',
      subtitleDashboard: 'Overview of your administration panel',
      subtitleNews: 'Manage published news and articles',
      subtitleSchool: 'Manage school page content',
      subtitleSchoolNews: 'Manage school related news',
      deleteTitle: 'Confirm deletion',
      deleteQuestionStart: 'Are you sure you want to delete the news item',
      deleteQuestionEnd: '?',
      deleteWarning: 'This action cannot be undone.',
      cancel: 'Cancel',
      accept: 'Accept',
      editNewsTitle: 'Edit news',
      editSchoolNewsTitle: 'Edit school news',
      fieldTitle: 'Title',
      fieldContent: 'Content',
      fieldPublishDate: 'Publish date',
      saveChanges: 'Save changes',
      quillPlaceholder: 'Write the news content here...',
    },
  },
} as const;
